export default __webpack_public_path__ + "static/media/Increment2.986feaa0.svg";